export default __webpack_public_path__ + "static/media/cv.cb874974.pdf";